<p-toast></p-toast>
<div class="p-3">
  <div class="page-title d-flex justify-content-between align-items-center">
    <div>
      <h3>Amenities Listing</h3>
    </div>
    <div>
      <p-button class="primary-btn" [style.margin-right]="'0.3rem'" icon="pi pi-sync" (click)="clearFilters()"
        [outlined]="true"></p-button>
      <p-button pButton type="button" label="Create Amenity" icon="pi pi-plus" class="primary-btn"
        (click)="showDialog('right')"></p-button>
    </div>
  </div>

  <div class="filters">
    <div class="filters-container w-100 m-0">
      <div class="p-1">
        <label for="search" class="dropdown-label">Search</label>
        <input type="text" style="padding: .3rem .75rem;" pInputText [(ngModel)]="searchQuery" 
          (input)="onSearch(); sanitizeInput($event)"
          (keydown)="blockSpecialChars($event)"
          (paste)="blockSpecialCharsOnPaste($event)"
          (drop)="blockSpecialCharsOnDrop($event)"
          placeholder="Search amenities..." class="w-full" class="form-control" />
      </div>
      <div class="p-1">
        <label for="category" class="dropdown-label">Category</label>
        <p-dropdown [options]="categories" [(ngModel)]="selectedCategory" (onChange)="onCategoryChange()"
          placeholder="Select Category" [showClear]="true" class="w-full"></p-dropdown>
      </div>
    </div>
  </div>

  <div class="amenities-listing p-4 mt-3 m-1">
    <p-table [value]="amenities" [lazy]="true" (onLazyLoad)="loadAmenities($event)" [paginator]="true" [rows]="rows"
      [totalRecords]="totalRecords" [rowsPerPageOptions]="[10,20,50]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [sortField]="sortField"
      [sortOrder]="sortOrder" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">
            Name
            <p-sortIcon field="name"></p-sortIcon>
          </th>
          <th pSortableColumn="amenity_category_name">
            Category Name
            <p-sortIcon field="amenity_category_name"></p-sortIcon>
          </th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-amenity>
        <tr>
          <td>{{ amenity.name }}</td>
          <td>{{ amenity.amenity_category_name }}</td>
          <td>
            <p-button icon="pi pi-pencil" class="icon-primary-btn" (click)="editAmenity(amenity)"></p-button>
            &nbsp;
            <p-button icon="pi pi-trash" class="icon-secondary-btn" (click)="deleteAmenity(amenity)"></p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog header="{{selectedAmenity ? 'Update' : 'Create'}} Amenity" [modal]="true" [(visible)]="visible" [position]="position" [style]="{ width: '35%' }"
  draggable="false">
  <app-create-amenity
    [amenityToEdit]="selectedAmenity"
    [hostPropertyId]="propertyId"
    (amenitySaved)="onAmenitySaved()"
  ></app-create-amenity>
</p-dialog>

<div class="dlt-confirmation-dialog">
  <p-dialog header="Confirm Delete" [(visible)]="displayDeleteModal" [modal]="true" [closable]="false">
    <small><i class="pi pi-exclamation-triangle text-danger"></i> Are you sure you want to delete this amenity?</small>
    <p-footer>
      <p-button type="button" class="secondary-btn" [style.margin-right]="'0.3rem'"  pbutton label="No" icon="pi pi-times" (click)="onCancel()"></p-button>
      <p-button type="button" class="primary-btn" pbutton label="Yes" icon="pi pi-check" (click)="onConfirm()"></p-button>
    </p-footer>
  </p-dialog>
</div>
